import { TranslationKey } from '@Localization';
import { AutocompleteProps } from '@mui/joy';
import { ReactElement } from 'react';
import { S_FieldError } from '../../design/errors/fieldError/S_FieldError';
import { Select } from '../../design/inputs/select/Select';
import { S_FieldLabel } from '../../design/labels/fieldLabel/S_FIeldLabel';

interface IValidatedMultiSelectInputProps<T, DisableClearable extends boolean | undefined, FreeSolo extends boolean | undefined> extends AutocompleteProps<
  T,
  true,
  DisableClearable,
  FreeSolo
> {
  isValid?: boolean;
  feedbacks?: TranslationKey[];
  label?: string;
  isRequired?: boolean;
}

export const ValidatedMultiSelectInput = <T, DisableClearable extends boolean | undefined = true, FreeSolo extends boolean | undefined = false>({
  isValid,
  label,
  isRequired,
  feedbacks,
  ...rest
}: IValidatedMultiSelectInputProps<T, DisableClearable, FreeSolo>): ReactElement => {
  let validationClass = '';
  if (isValid !== undefined) {
    validationClass = isValid ? 'is-valid' : 'is-invalid';
  }

  return (
    <div className='validated-select-input'>
      <div>
        {label && (
          <S_FieldLabel
            isRequired={isRequired}
            text={label}
          />
        )}
        <Select
          multiple
          className={validationClass}
          {...rest}
        />
        {feedbacks && <S_FieldError feedbacks={feedbacks} />}
      </div>
    </div>
  );
};
